/* Copyright (c) 2020-present CloudIO Inc */

export function isChrome() {
  return navigator.userAgent.indexOf('Chrome') > -1;
}
